export default {
    membership_management: {
        no_membership_number: 'Complete your first investment to become a member.',
        membership_number: 'Membership number',
        download_document: 'Download membership document',
        send_document: 'Receive form by mail',
        send_document_requested: 'Document mailing requested',
        send_document_sent: 'Document has been sent',
        document_label: 'Membership document',
        order_certificates: 'Investment Certificate',
    },
    account_dropdown_log_out: 'Log out',
    account_dropdown_company_account: 'Company account',
    account_dropdown_tooltip_account: 'Investor account',
    account_dropdown_tooltip_fill_account_data: 'Please complete your investor data',
    account_dropdown_tooltip_orders: 'Investments',
    account_dropdown_tooltip_wallets: 'Wallet',
    personal_account: 'Account overview',
    welcome: 'Welcome',
    header_new_investor: 'New investor?',
    header_register: 'Register',
    header_sign_in: 'Sign in',
    header_sign_in_new: 'Login',
    header_register_new: 'Register',
    header_new_to_invest_new: 'New investor?',
    header_modal_body_new:
        'If this is your first investment, please sign up. Have you already invested on CONDA Capital Market or CONDA Crowdinvesting? Then you can login with your existing credentials.',
    header_modal_title_new: 'You need a user account to invest',
    header_unfinished_investment_process: 'You have an investment in progress',
    email_verification_already_verified: 'Your email address has already been verified',
    email_verification_email_pending_missmatch:
        'The email address could not be verified. Another email verification was started in the meantime. Please try again.',
    email_verification_expired_link: 'The confirmation link has expired.',
    email_verification_verified: 'Your email address has been successfully changed!',
    create_company_profile_question: 'Do you want to create a company account for your account?',
    create_company_profile: 'Create company account',
    language_switcher_select_language: 'Select language',
    discard: 'Cancel',
    header: {
        sign_in: 'Sign in',
        register: 'Register',
        new_to_invest: 'New investor?',
    },
    kyc_provider: {
        idnow: 'IDNow',
        signteq: 'Signteq',
    },
    pay_via_eth: 'Pay via ETH',
    gas_limit: 'Gas Price',
    address_to_send_eth: 'Recipient address for ETH',
    pay_via_eth_desc:
        'Paying with ETH: If you use bank transfer as your payment option, an additional fee will apply, based on your total investment amount. Additional fee for transferring your investment.',
    portfolio_size: 'Portfolio size',
    view_details: 'View details',
    date: 'Date',
    time: 'Time',
    total: 'Total',
    investment: 'Investment',
    investment_amount: 'Investment amount',
    support_amount: 'Support amount',
    order_status_canceled: 'Canceled',
    order_status_pending: 'Pending',
    order_status_paid: 'Paid',
    order_status_approved: 'Approved',
    order_status_covered: 'Covered',
    order_status_accepted: 'Accepted',
    my_orders_side: 'My investments',
    no_order: 'No investment',
    order_voucher_amount: 'Amount from voucher',
    order_discount_voucher_amount: 'Amount from discount voucher',
    order_wallet_amount: 'Amount from wallet',
    success: '',
    error: '',
    copy: '',
    save: '',
    copy_to_clipboard: '',
    copied_to_clipboard: '',
    errors: {
        validation_error: '',
        general_error: '',
        kyc_id_required: 'KYC is required to proceed with the investment',
        kyc_bank_required: 'Bank verification is required to proceed with the investment',
        kyc_address_required: 'Address verification is required to proceed with the investment',
        kyc_tax_required: 'Tax verification is required to proceed with the investment',
    },
    terms_link: '',
    privacy_link: '',
    admin_email: '',
    contact_support: '',
    investment_process: {
        close: 'Close',
        pay_now: 'Pay now',
        cancel: 'Cancel',
        accept_savings_plan: 'Savings plan',
        accept_gift_membership: 'Gift membership',
        visit_faq_url: 'For more info click here',
        emission_agio_text: '',
        emission_disagio_text: '',
        sign_digitally: '',
        show_document: 'Show Document',
        signature: 'Signature',
        confirm_signature: 'Confirm signature',
        reset_verification_header: 'We need to reset your verification',
        // prettier-ignore
        payment_processing:
            'Your payment is being processed. Follow the instructions in the payment provider\'s window. Please do not close this page.',
        payment_successful: 'Payment successful.',
        payment_failed: 'Payment failed.',
        try_again: 'Try again',
        prepaid_payment_successful:
            'Your payment is being processed. The status of your investment will be updated once payment has been successfully received.',
        // prettier-ignore
        reset_verification_body:
            'Since you have been verified by our former partner IDnow, a new verification via Signteq is required before you can invest.<br><br>' +
            'Please contact us via email at <a href="mailto:support{\'@\'}conda-capital.com">support{\'@\'}conda-capital.com</a>, to reset the verification process.',
        signature_legal_notice: '',
        signature_legal_notice_title: '',
        nyala_vault: '',
        or: '',
        download_signature_document: '',
        signature_document: 'Signature document',
        law_requirements: '',
        summary: '',
        payment: '',
        contract_period: '',
        issuer: 'Issuer',
        minimum_investment: '',
        steps: '',
        next: '',
        back: '',
        time_left: '',
        to_the_landing_page: '',
        thank_you_for_you_investment: '',
        pay_via_bank_transfer_header: '',
        pay_via_bank_transfer_description: '',
        go_to_my_orders: '',
        please_accept_all_documents: '',
        please_accept_all_disclaimers: '',
        please_accept_all_warnings: '',
        wallet_retrievable_balance: 'Retrievable balance on wallet',
        voucher_available_balance: 'Available balance on voucher',
        update_wallet_amount: 'Adjust wallet balance',
        apply_wallet_amount: 'Activate wallet balance',
        update_voucher_amount: 'Adjust voucher balance',
        apply_voucher_amount: 'Activate voucher balance',
        discount_code_applied_successfully: 'Discount code applied successfully',
        discount_code_higher_than_amount:
            'Discount code cannot be applied, as the discount is higher than the remaining amount.',
        available: 'available',
        discount_code: 'Discount code',
        apply_discount_button: 'Activate',
        activate_balance: '',
        public_name_consent: '',
        disclaimers: '',
        understand_all_risks: '',
        contract_documents: '',
        accept_all_documents: '',
        accept_all_warnings: '',
        investment_warnings: '',
        investment_warnings_description: '',
        pre_contractual_cooling_off_period: '',
        pre_contractual_cooling_off_period_description: '',
        incentives: '',
        incentive: '',
        selected_incentive: '',
        select_incentive: '',
        which_contract_type: '',
        voucher_title: '',
        voucher_description: '',
        cash_title: '',
        cash_description: '',
        enter_investment_amount: '',
        min_amount: '',
        max_amount: '',
        step_level: '',
        invest: '',
        depot_additional_fields: 'Information about your securities account',
        depot_owner: 'Account holder',
        depot_number: 'Account number',
        depot_bank: 'Bank',
        depot_bic: 'BIC or bank code',
        enter_investment_pieces: '',
        emission_pieces_to_amount: '',
        emission_amount_to_pieces: '',
        investment_summary: 'Investment summary',
        investment_amount: '',
        wallet_amount: 'Wallet balance',
        wallet_amount_description: 'Please select the amount you want to cover with your existing wallet balance',
        voucher_amount: '',
        voucher_amount_description: 'Please select the desired voucher and the amount you want to activate.',
        expires_at: 'Expires at',
        contract_type: '',
        amount_to_pay: '',
        registration_number: 'Company registration number:',
        address: 'Address',
        invest_as_natural_profile: 'Invest as natural profile',
        invest_as_legal_profile: 'Investing as a company',
        invest_in: 'Invest in',
        create_order: '',
        payment_account_holder_default: '',
        pay_via_credit_card_header: '',
        pay_via_credit_card_description: '',
        pay_via_credit_card_button: 'Pay via credit card ',
        verification_outstanding: '',
        verification_outstanding_description: '',
        verify_button: 'Verify now',
        broker: '',
        broker_id: '',
        please_provide_broker_id: 'Please provide your broker ID',
        please_confirm: '',
        please_confirm_your_details: '',
        please_fill_required_fields: '',
        note: 'note',
        email_must_match_profile: 'The email address you entered does not match your profile.',
        first_name_must_match_profile: 'The first name you entered does not match your profile.',
        last_name_must_match_profile: 'The last name you entered does not match your profile.',
        ecsp: {
            not_enough_experience_title: '',
            not_enough_experience_description: '',
            not_enough_risk_acknowledgements_title: '',
            not_enough_risk_acknowledgements_description: '',
            investment_too_high_title: '',
            investment_too_high_description: '',
        },
        altfg: {
            investment_process_altfg_notice: '',
            investment_process_altfg_choice_notice: '',
            investment_process_altfg_professional_investor: '',
            investment_process_altfg_legal_entity: '',
            investment_process_altfg_maximum_net_income: '',
            investment_process_altfg_maximum_assets: '',
        },
        vermanlg: {
            personal_data_verification_note:
                'Please ensure that the data you entered matches your personal information exactly (including periods and commas). Otherwise, the error message "Data incomplete" will appear. In this case, please check again.',
            vib_investor_from_germany: '',
            investments_information_sheet: '',
            vib_current_location: '',
            vib_date: '',
            vib_email: '',
            vib_first_name: '',
            vib_last_name: '',
            vib_place_of_birth: '',
            vib_date_of_birth: '',
            vib_id_card_passport_number: '',
            issuing_authority: '',
            vib_address: '',
            vib_postal_code: '',
            vib_city: '',
            vib_state: '',
            vib_tax_number: '',
            vib_investment_information: '',
            vib_investment_under_1000: '',
            vib_investment_financial_assets_over_10000: '',
            vib_investment_income_over_1k: '',
            vib_investment_income_over_10k: '',
            vib_investment_limit_part_1: '',
            vib_investment_limit_part_2: '',
            vermanlg_confirm_section_note: '',
            vermanlg_right_of_withdrawal: '',
            vermanlg_right_of_withdrawal_disclaimer: '',
            vermanlg_consequences_of_revocation: '',
            vermanlg_consequences_of_revocation_disclaimer: '',
        },
        stock_price: 'Stock price',
        stock: 'Shares',
        agio: 'Agio',
        disagio: 'Disagio',
        per_share: 'per share',
        pre_emptive_rights_notice_title: 'Pre-emptive rights required',
        pre_emptive_rights_notice_body:
            'An investment in this campaign requires pre-emptive rights. You currently hold:',
        pre_emptive_rights_units: 'right(s)',
    },
    forms: {
        select_option: '',
        radio_no: '',
        radio_yes: '',
        radio_male: '',
        radio_female: '',
        day: '',
        month: '',
        year: '',
        dd: '',
        mm: '',
        yyyy: '',
    },
    account: {
        investor_account: '',
        my_profile: '',
        first_name: '',
        last_name: '',
        save: '',
        date_of_birth: '',
        nationality: '',
        address: 'Address',
        postal_code: '',
        city: '',
        same_as_residential: '',
        country_of_birth: '',
        city_of_birth: '',
        // prettier-ignore
        esac_locked_account_info:
            'In order to change or update profile or KYC information and documents, please contact the ESAC team by mail via platform{\'@\'}superangels.club',
        phone_number: '',
        iban: '',
        bic: '',
        social_security_number: '',
        tax_number: '',
        mobile_number: '',
        current_email: '',
        email_pending: '',
        new_email: '',
        email_address: '',
        country: '',
        state: '',
        gender: '',
        gender_placeholder: '',
        pep: '',
        pep_past: '',
        pep_position: '',
        saved_successfully_title: '',
        saved_successfully_message: '',
        saved_kyc_successfully_message: '',
        average_investment_transaction_amount: '',
        average_investment_transactions_per_year: '',
        investment_transactions: '',

        experience_share: '',
        experience_bond: '',
        experience_participation_paper: '',
        experience_crypto_currency: '',
        experience_unsecured_junior_debt: '',
        knowledge_share: '',
        knowledge_bond: '',
        knowledge_participation_paper: '',
        knowledge_crypto_currency: '',
        knowledge_unsecured_junior_debt: '',

        experience_with_securities: '',
        experience_without_advice: '',
        experience_with_asset_management: '',
        experience_with_investment_advice: '',

        bonds: '',
        stocks: '',
        market_funds: '',
        investment_funds: '',
        experience_investment_forms: '',
        current_occupation: '',
        highest_educational_attainment: '',
        default_language: 'Standard language',
    },
    portfolio: {
        investments_total: '',
        open_investments: '',
        my_investments: '',
        secondary_market_pre_emptive_rights_title: 'Secondary Market - My Pre-emptive Rights',
        rights_unit: 'Pre-emptive rights',
        unit_short: 'pcs.',
        no_investments_to_show: '',
        orders: {
            order_status: '',
            order_status_active: '',
            order_status_completed: '',
            order_status_canceled: '',
            order_status_pending: '',
            order_status_paid: '',
            order_status_approved: '',
            order_status_covered: '',
            order_status_accepted: '',
            contract_documents: 'Contract Documents',
            reporting_documents: 'Reporting Documents',
            additional_documents: 'Additional Documents',
            order_certificate: 'Investment Certificate',
            investment_details: 'Investment Details',
            investment_date: 'Investment Date',
            start_of_contract: 'Start of Contract',
            cancel_period_remaining:
                'You can cancel this investment within {days} day(s). This action cannot be undone.',
            cancel_order: 'Cancel Investment',
            confirm_cancel_order: 'Are you sure you want to cancel this investment? This action cannot be undone.',
        },
    },
    investment_targets: {
        investment_objectives: 'Your investment objectives',
        // prettier-ignore
        legal_investment_objectives: 'Entity\'s investment objectives',
        security_coverage: 'Pension plan',
        security_coverage_or_pension_plan: 'Security coverage of the severance payment or pension plan',
        pension_provision: 'Pension provision',
        retention_of_assets: 'Retention of assets',
        distribution_of_assets: 'Distribution of assets',
        capital_gain: 'Capital gain',
        investment_horizon: 'Your Investment horizon',
        // prettier-ignore
        legal_investment_horizon: 'Entitiy\'s investment horizon',
        investment_frequency:
            'Frequency of your investment in alternative assets (including Venture Capital and Private Equity)',
        // prettier-ignore
        legal_investment_frequency:
            'Frequency of entity\'s investment in alternative assets (including Venture Capital and Private Equity):',
    },
    financial_conditions: {
        financial_assets: 'Financial assets (in EUR)',
        annual_operating_result: 'Annual income (in EUR)',
        dept_capital: 'Debt capital (in EUR)',
        properties: 'Property ownership',
        source_of_funds: 'Source of funds (this is the origin of the specific funds you will be investing)',
        dividends_or_profits: 'Dividends or profits from investments',
        lottery_gambling: 'Lottery/gambling',
        divorce: 'Divorce',
        maturity_or_surrender: 'Maturity or surrender of life insurance policy',
        gift: 'Gift',
        inheritance: 'Inheritance',
        insurance_claims: 'Insurance Claims',
        sale_of_property: 'Sale of property',
        savings: 'Savings',
        loan: 'Loan',
        other: 'Other',
        industry: 'Industry of your main business activity and/or your occupation:',
        // prettier-ignore
        business_industry: 'Sector of the entity\'s main business activity:',
        dividends_or_profits_legal: 'Dividends or profits from holdings/investments/assets',
        retained_earnings: 'Retained earnings',
    },
    fatca_declaration: {
        cannot_continue: 'Unfortunately, you cannot complete the KYC process online.',
        financial_institutions_under_fatca:
            'FATCA classification of the company: Is the entity a Financial institution (FI) under FATCA?',
        // prettier-ignore
        contact_support: 'Please contact Venionaire at platform{\'@\'}superangels.club.',
        us_citizen_or_resident: 'Are you a U.S. citizen and/or resident in the U.S. for tax purposes?',
        non_financial_entity_reason:
            'Please select one of the following categories as to which type of NFE the investor (Legal Entity) is',
        financial_institution_category:
            'Financial Institutions under FATCA: Please select on of the following categories:',
        us_entity: 'Is the entity a U.S. Person pursuant to FATCA regulations?',
        provide_giin: 'Can you provide the GIIN of the registry holder obtained for FATCA purposes',
        no_giin_reason:
            'If the company is a financial institution but cannot issue a GIIN, please tick one of the following reasons:',
        giin: 'Please provide the GIIN of the Entity obtained for FATCA purposes:',
        giin_sponsor_name: 'Name of Sponsor',
        giin_sponsor: 'GIIN of Sponsor',
    },
    crs_classification: {
        company_classification: 'CRS Classification of the company:',
        stock_exchange_name:
            'Please provide the name of the established stock exchange where the company’s shares are regularly traded:',
        affiliate_stock_exchange_name:
            'Or If you are an affiliate of a company regularly traded on an established securities exchange, please provide the name of the established securities exchange and that company:',
    },
    country_tax_residencies: {
        add_another_tax_residence: 'Add another Tax Residence',
        cant_obtain_tin: 'I cannot obtain a TIN',
        tax_situation: 'Your tax situation',
        tax_residency: 'Tax residency',
        capital_gains: 'Capital gains tax exemption (KESt)',
        foreign_assets_ownership: 'Ownership of Foreign Assets',
        foreign_assets: 'Foreign assets',
        capital_gains_legal: 'Capital gains tax exemption (KESt)',
        corporate_tax_exemption: 'Corporate tax exemption (KÖSt)',
        group_taxation: 'Group taxation',
    },
    legal_acknowledgements: {
        risks_acknowledgement:
            'I/we acknowledge that Venionaire Ventures S.à r.l. ("VV") will not accept an application for the purchase of fund units in any case if no information is provided on the risk disposition. In addition, I/we acknowledge that, in addition to the risks listed, fluctuations in value that arise because of currency changes (including inflation) may occur.',
        // prettier-ignore
        anti_money_laundering:
            'In accordance with the amended Anti-Money Laundering and Counter-Terrorism Financing Act of 12 November 2004, I/we declare that the UBO(s) disclosed is/are the ultimate beneficial owner(s) of the Investor and undertake to advise VV\'s auditor of any change in the Investor\'s shareholding, voting rights or ultimate beneficial owner(s). I/we also declare that the origin of the funds and securities used to carry out the      Investor\'s operations do not contravene that Act. I/we finally declare that the intended use of the assets emanating from these operations will also not contravene that Act.',
        authorised_signatory:
            'I/we certify that I/we is/are the authorised signatory(ies) of the Investor and acknowledge that, pursuant to Article 5 of the Luxembourg CRS Law, it is mandatory to answer questions related to the information disclosed regarding tax self-certification.',
        tax_authorities:
            'In particular, I/we acknowledge and agree that the information disclosed may be reported to the tax authorities in Luxembourg or other authorised delegates under Luxembourg law in accordance with the information required in respect of financial accounts (see Annex I,      Section I of the Law " Loi du 18 décembre 2015 relative à la Norme      Commune de Déclaration (NCD)", hereinafter "Luxembourg CRS      Law") in respect of the Investor or its ultimate beneficial owner(s)      and any reportable register. Furthermore, i/we acknowledge and agree that the information disclosed may be exchanged with the tax authorities of the country(ies) in which I/we and/or the Investor has/have established a tax residence in accordance with intergovernmental tax data exchange agreements.',
        intergovernmental_tax_exchange:
            'I/we authorise VV to forward/exchange all information disclosed, as well as the information necessary for reporting under the intergovernmental tax data exchange agreements, as described above, with the competent tax authorities of the country or countries.',
        notify_about_changes:
            'I/we undertake to notify VV within 30 days of any changes affecting the self-certification and of any changes affecting the information provided and to provide VV with a correspondingly updated self-certification without delay and without request. I/we will have access, upon request, to the data concerning me/us/the Investor/the UBO(s)      that will be disclosed to the Luxembourg tax authorities and will be able to rectify the personal data. The data collected will not be stored longer than necessary for the purposes of the Luxembourg CRS Law.',
        information_correct_and_complete:
            'I/we declare that all information given by me/us is correct and complete to the best of my/our knowledge and belief.',
    },
    acknowledgements: {
        check_all: 'Check all',
        currency_change_risk:
            'I/we acknowledge that Venionaire Ventures S.à r.l. ("VV") will not accept an application for the purchase of fund units in any case if no information is provided on the risk disposition. In addition, I/we acknowledge that, in addition to the risks listed, fluctuations in value that arise because of currency changes (including inflation) may occur.',
        own_account:
            'I/we certify that I/we is/are the authorised signatory(ies) of the Investor and acknowledge that, pursuant to Article 5 of the Luxembourg CRS Law, it is mandatory to answer questions related to the information disclosed regarding tax self-certification.',
        // prettier-ignore
        anti_money_laundering:
            'In accordance with the amended Anti-Money Laundering and Counter-Terrorism Financing Act of 12 November 2004, I/we declare that the UBO(s) disclosed is/are the ultimate beneficial owner(s) of the Investor and undertake to advise VV\'s auditor of any change in the Investor\'s shareholding, voting rights or ultimate beneficial owner(s). I/we also declare that the origin of the funds and securities used to carry out the      Investor\'s operations do not contravene that Act. I/we finally declare that the intended use of the assets emanating from these operations will also not contravene that Act.',
        self_certification_form:
            'In particular, I/we acknowledge and agree that the information disclosed may be reported to the tax authorities in Luxembourg or other authorised delegates under Luxembourg law in accordance with the information required in respect of financial accounts (see Annex I, Section I of the Law " Loi du 18 décembre 2015 relative à la Norme Commune de Déclaration (NCD)", hereinafter "Luxembourg CRS Law") in respect of the Investor or its ultimate beneficial owner(s) and any reportable register. Furthermore, i/we acknowledge and agree that the information disclosed may be exchanged with the tax authorities of the country(ies) in which I/we and/or the Investor has/have established a tax residence in accordance with intergovernmental tax data exchange agreements.',
        tax_data_exchange_agreement:
            'I/we authorise VV to forward/exchange all information disclosed, as well as the information necessary for reporting under the intergovernmental tax data exchange agreements, as described above, with the competent tax authorities of the country or countries.',
        report_changes:
            'I/we undertake to notify VV within 30 days of any changes affecting the self-certification and of any changes affecting the information provided and to provide VV with a correspondingly updated self-certification without delay and without request. I/we will have access, upon request, to the data concerning me/us/the Investor/the UBO(s)      that will be disclosed to the Luxembourg tax authorities and will be able to rectify the personal data. The data collected will not be stored longer than necessary for the purposes of the Luxembourg CRS Law.',
        complete_and_correct_information:
            'I/we declare that all information given by me/us is correct and complete to the best of my/our knowledge and belief.',
    },
    experience_and_knowledge: {
        experience: 'Investment Experience',
        knowledge: 'Knowledge',
        stocks_equity_funds: 'Stocks, equity funds',
        mixed_funds_etfs: 'Mixed funds, ETFs',
        bonds_bond_funds: 'Bonds, bond funds',
        closed_ended_funds: 'Closed-ended funds',
        options_other_derivatives: 'Options, other derivatives',
        venture_capital: 'Venture capital',
        other_shares_loans_in_private_companies: 'Other shares/loans in private companies',
        other_alternative_investments: 'Other alternative investments (hedge funds, commodity funds, etc.)',
        follow_market_prices_business_financial_news:
            'How often do you check market prices, business and financial news ?',
    },
    follow_market_options: {
        regularly: 'regularly',
        occasionally: 'occasionally',
        rarely: 'rarely',
        not_at_all: 'not at all',
    },
    investment_knowledge: {
        advanced: 'advanced',
        basic: 'basic',
        none: 'none',
    },
    investment_horizon: {
        short_term: 'short-term (< 5 years)',
        medium_term: 'medium-term (5-10 years)',
        long_term: 'long-term (11-20 years)',
        very_long_term: 'very long-term (> 20 years)',
    },
    investment_frequency: {
        one_off: 'one-off',
        monthly: 'monthly',
        quarterly: 'quarterly',
        semi_annually: 'semi-annually',
        annually: 'annually',
    },
    risk_tolerance: {
        label: 'Your risk tolerance is:',
        // prettier-ignore
        label_legal: 'Investor\'s (Legal Entity\'s) Risk Tolerance:',
        low: 'Low',
        medium: 'Medium',
        advanced: 'Advanced',
        high: 'High',
    },
    verification: {
        pdf_both_sides: 'PDF both sides',
        upload_id_pdf: 'Click here to upload the file (PDF)',
        upload_id_image: 'Click here to upload the file (JPG, PNG, JPEG)',
        upload_id_pdf_and_image: 'Click here to upload the file (PDF and JPG, PNG, JPEG)',
        full_name: 'Full Name',
        company_email: 'Company Email',
        role: 'Role',
        email: 'Email',
        identity_verification: '',
        identity_verification_subheadline: '',
        identity_verification_upload_notice: '',
        tax_verification: '',
        bank_verification: 'Bank verification',
        bank_verification_headline: '',
        address_verification: 'Address verification',
        address_verification_headline: '',
        address_verification_subheadline: '',
        legal_verification: 'Legal verification',
        legal_verification_subheadline: '',
        legal_bank_verification: 'Legal bank verification',
        legal_bank_verification_subheadline: '',
        upload_label: 'Upload label',
        upload_invalid_field: 'Upload invalid field',
        upload_waiting_for_size: 'Upload waiting for size',
        upload_size_not_available: 'Upload size not available',
        upload_loading: 'Upload loading',
        upload_load_error: 'Upload load error',
        upload_processing: 'Upload processing',
        upload_processing_complete: 'Upload processing complete',
        upload_processing_aborted: 'Upload processing aborted',
        upload_processing_error: 'Upload processing error',
        upload_processing_revert_error: 'Upload processing revert error',
        upload_file_remove_error: 'Upload file remove error',
        upload_tap_to_cancel: 'Tap to cancel',
        upload_tap_to_retry: 'Tap to retry',
        upload_tap_to_undo: 'Tap to undo',
        upload_button_remove_item: 'Remove item',
        upload_button_abort_item_load: 'Abort item load',
        upload_button_retry_item_load: 'Retry item load',
        upload_button_abort_item_processing: 'Abort item processing',
        upload_button_undo_item_processing: 'Undo item processing',
        upload_button_retry_item_processing: 'Retry item processing',
        upload_button_process_item: 'Process item',
        tax_verification_headline: '',
        complete_data: 'Complete data',
        complete_data_description: 'Complete data description',
        complete_data_description_for_verification: 'Complete data description for verification',
        complete_data_description_short: 'Complete data description short',
        complete_verification_outstanding: 'Complete verification outstanding',
        complete_verification_complete: 'Complete verification complete',
        completed_data: 'Completed data',
        completed_data_description: 'Completed data description',
        complete_data_action_button: 'Complete data action button',
        kyc_process: 'Perform verification',
        kyc_process_description: 'In order to be able to make investments, you must verify yourself.',
        kyc_process_action_button: 'Verify',
        old_value: 'Old value',
        no_changes: 'All data matches the previously provided information.',
        save: 'Save',
        depot: 'Securities account',
        depot_verification_subheadline: 'Please provide the necessary information about your securities account here.',
        new_value: 'New value',
        override_data: 'Override data',
        override_data_description: 'Override data description',
        verification_successful: 'Verification successful',
        verification_successful_description: 'Verification successful description',
        status_not_started: 'Status not started',
        status_not_started_description: 'Status not started description',
        status_created: 'Status created',
        status_created_description: 'Status created description',
        status_in_review: 'Status in review',
        status_in_review_description: 'Status in review description',
        status_data_changed: 'Status data changed',
        status_data_changed_description: 'Status data changed description',
        status_success: 'Status success',
        status_success_description: 'Status success description',
        status_failure: 'Status failure',
        status_failure_description: 'Status failure description',
        id_now_kyc_continue_button: 'IDNow KYC continue button',
        id_now_kyc_waiting_for_id_now_button: 'IDNow KYC waiting for IDNow button',
        id_now_kyc_restart_button: 'IDNow KYC restart button',
        id_now_kyc_start_button: 'IDNow KYC start button',
        ecsp_status_rejected: 'Not qualified - rejected',
        ecsp_status_pending: 'Not qualified - verification pending',
        ecsp_status_expert: 'Qualified',
        ecsp_status_non_expert: 'Not qualified',
        signteq_kyc_start_button: 'Start KYC verification',
        signteq_kyc_restart_button: 'Restart KYC process',
        schedule_kyc_support: 'If you have trouble completing the KYC process, please contact support from here:.',
        schedule_kyc_contact_support_button: 'Contact support here',
    },
    camera: {
        click_here_to_capture_image: 'Click here to take a photo',
        close: 'Close camera',
        or: 'or',
    },
    id_front: 'Front',
    id_back: 'Back',
    newsletter_verification_success: 'Your email newsletter subscription has been successfully confirmed!',
    membership_document: {
        status: {
            accepted: 'Accepted',
            pending: 'Pending',
            rejected: 'Rejected',
        },
    },
    ecsp: {
        natural: {
            info_text: '',
            info_text_highlight_one: '',
            info_text_highlight_two: '',
            info_text_highlight_three: '',
            info_text_link_placeholder: '',
            investor_classification: {
                expert_investor_explanation: '',
            },
            experience: {
                no_answer: '',
                financial_education: '',
                bonds_knowledge: '',
                bonds_investment_frequency: '',
                stocks_knowledge: '',
                stocks_investment_frequency: '',
                convertible_bonds_knowledge: '',
                convertible_bonds_investment_frequency: '',
            },
            risk: {
                no_answer: '',
                startup_investing: '',
                investments_outside_stock_market: '',
                subordinated_financial_instruments: '',
                profit_participation_certificate: '',
            },
        },
        legal: {
            info_text: '',
            info_text_link_placeholder: '',
            investor_classification: {
                expert_investor_explanation: '',
            },
            risk: {
                most_startups: '',
                dividends: '',
                higher_interest_rates: '',
                secure_investment: '',
                stocks_bankrupt_company: '',
                good_long_term_investment: '',
                return_on_investment: '',
            },
        },
        investment_frequency: {
            less_than_5_times: '',
            more_than_5_times: '',
            no_answer: '',
        },
        investment_horizon: {
            two_years: '',
            up_to_5_years: '',
            more_than_5_years: '',
            no_answer: '',
        },
        startup_investing: {
            high_return_low_risk: '',
            loss: '',
            growth: '',
        },
        investments_outside_stock_market: {
            low_risk: '',
            high_risk: '',
            high_proportion: '',
        },
        subordinated_financial_instruments: {
            insolvency_quote: '',
            equal_with_other_creditors: '',
            lose_investment: '',
        },
        profit_participation_certificate: {
            participate_profits_losses: '',
            fixed_interest_amount: '',
            transfer_to_company: '',
        },
        investor_classification: {
            expert_investor_treatment: '',
            self_disclosure_explanation: '',
            self_disclosure: '',
            print: '',
            upload_self_disclosure: '',
        },
        financial_education: {
            professional_experience: '',
            relevant_degree: '',
            both: '',
            none: '',
        },
        investment_goals: {
            no_answer: '',
            sustainability: '',
            investment_goal: '',
            investment_horizon: '',
        },
        sustainability: {
            very_true: '',
            applies: '',
            does_not_apply: '',
            no_answer: '',
        },
        investment_goal: {
            wealth_building: '',
            speculative_investments: '',
            no_answer: '',
        },
        most_startups: {
            successful: '',
            fail: '',
        },
        dividends: {
            equity: '',
            debt_capital: '',
        },
        higher_interest_rates: {
            secure_investment: '',
            risk_investment: '',
        },
        secure_investment: {
            bond_brd: '',
            bond_us_treasury: '',
            vw_share: '',
        },
        stocks_bankrupt_company: {
            refund: '',
            loss: '',
        },
        good_long_term_investment: {
            company_investment_portfolio: '',
            scatter_investments: '',
        },
        return_on_investment: {
            less_than_5_years: '',
            more_than_5_years: '',
        },
        financial_situation: {
            calculate: '',
            no_value: 'N/A',
            net_worth: '',
            net_worth_tooltip: '',
            loss_bearing_capacity: '',
            loss_bearing_capacity_tooltip: '',
            annual_net_income: '',
            annual_net_income_tooltip: '',
            annual_financial_commitments: '',
            annual_financial_commitments_tooltip: '',
            calculation_of_net_worth: '',
            liquid_funds: '',
            liquid_funds_tooltip: '',
            info_text: '',
        },
    },
    legal_account: {
        company_profile: '',
        company_name: '',
        registration_number: '',
        legal_form: 'Legal Form',
        registration_authority: 'Registration Authority',
        address: 'Address',
        description: '',
        postal_code: '',
        city: '',
        state: '',
        country: '',
        iban: '',
        bic: '',
        tax_number: '',
        saved_successfully_title: '',
        saved_successfully_message: '',
        investor_classification: '',
        risk: '',
        financial_situation: '',
        default_language: 'Default language',
    },
    beneficial_owner: {
        country_of_birth: '',
        city_of_birth: '',
        country_of_residence: '',
        no_beneficial_owners: '',
        no_beneficial_owners_description: '',
        indirect_ownership: 'Please indicate the respective company name in case of indirect ownership',
        remove: 'Remove',
    },
    highest_educational_attainment: {
        prefer_not_to_say: '',
        no_degree: '',
        secondary_school: '',
        junior_high_school: '',
        high_school_diploma: '',
        university: '',
    },
    investment_experience: {
        none: '',
        up_to_3_years: '',
        between_3_and_5_years: '',
        more_than_5_years: '',
    },
    average_investment_transaction: {
        none: '',
        up_to_5: '',
        between_5_and_10: '',
        over_10: '',
    },
    average_investment_amount: {
        up_to_3000_eur: '',
        between_3001_and_5000_eur: '',
        between_5001_and_10000_eur: '',
        over_10000_eur: '',
    },
    validation_error: {
        required: '',
        email: '',
        invalid: '',
        countryISO3166: '',
        iban: '',
        bic: '',
        new_email_not_equals_old: '',
        wrong_date_format: '',
        date_min: '',
        date_max: '',
        min_age: '',
        max_age: '',
        min_amount: '',
        min_amount_on_wallet: '',
        max_amount: '',
    },
    account_settings: {
        dashboard: '',
        personal_data: '',
        personal_data_headline: '',
        address_data: '',
        address_data_headline: '',
        address_data_subtitle: '',
        membership_management: 'Member management',
        nyala_vault: '',
        nyala_vault_headline: '',
        nyala_vault_subtitle: '',
        postal_address_data: 'Your postal address',
        compliance_profile: '',
        compliance_profile_subtitle: '',
        contact_data: '',
        contact_data_headline: '',
        contact_data_subtitle: '',
        security: '',
        security_headline: '',
        security_subtitle: '',
        verification: '',
        verification_headline: '',
        verification_subtitle: '',
        bank_data: '',
        bank_data_headline: '',
        bank_data_subtitle: '',
        tax_residencies: 'Tax Residencies',
        tax_data: '',
        overview: '',
        profile_data: '',
        legal_information: '',
        edit: '',
        legal_information_subtitle: '',
        current_status: '',
        crypto_wallet: '',
        crypto_wallet_headline: '',
        signatures: '',
        signatures_headline: '',
        signatures_subtitle: '',
        referral_program: '',
        referral_program_headline: '',
        referral_program_notice: '',
        investment_targets: 'Investor Profile',
        investment_targets_subtitle:
            'The investment horizon represents your basic willingness of investment duration. ',
        financial_conditions: 'Financial position',
        experience_and_knowledge: 'Investment Experience and Knowledge',
        risk_tolerance: 'Risk Tolerance',
        fatca_declaration: 'FATCA declaration',
        acknowledgements: 'Acknowledgements',
        kyc_form: 'KYC form',
        tax_situation: 'Tax Situation',
        investor_classification: '',
        experience: '',
        risk: '',
        investment_goals: '',
        financial_situation: '',
    },
    compliance_profile: {
        save_header: '',
        save_description: '',
        discard_header: '',
        discard_description: '',
        save_financial_data_header: '',
        save_financial_data_description: '',
        back_to_compliance_profile: '',
        status: 'Status: {status}',
        compliance_profile_complete_and_valid_description: 'Your compliance profile is complete and valid.',
        compliance_profile_complete_and_invalid_description: 'Your compliance profile is complete but invalid.',
        compliance_profile_incomplete_description: 'Your compliance profile is incomplete.',
        complete: 'Complete',
        incomplete: 'Incomplete',
        complete_data: 'Complete the compliance profile',
        complete_data_description: 'Please complete the data in your compliance profile to continue.',
        show_document: 'Show Document',
        upload_document: 'Upload new Document',
        edit_data: '',
        discard_data: '',
    },
    signatures: {
        complete_data_description_for_signatures: '',
        complete_compliance_profile: 'Complete the compliance profile',
        sign_document: '',
        sign_documents: '',
        not_signed: '',
        signed: '',
        no_signatures: '',
        no_signatures_description: '',
        pending_signatures: '',
        pending_signatures_description: '',
        show_document: '',
        dialog_close_button: '',
        regenerate_signatures: '',
        regenerate_signatures_notice: '',
        print: '',
    },
    account_settings_legal: {
        dashboard: '',
        company_data: '',
        overview: '',
        address_data: '',
        bank_data: '',
        tax_data: '',
        verification: '',
        verification_kyc_documents_subtitle: '',
        manager_area: '',
        manager_area_subtitle: '',
        beneficial_owners: '',
        beneficial_owners_subtitle: '',
        investment_objectives: 'Entity’s Investment Profile',
        financial_conditions: 'Entity’s financial position',
        risk_tolerance: 'Entity’s Risk Tolerance',
        tax_situation: 'Tax information',
        crs_classification: 'CRS Classification',
        acknowledgements: 'Acknowledgements',
    },
    legal_account_manager_beneficial_owner: {
        beneficial_owner: 'Beneficial Owner',
        manager: 'Manager',
        postal_address: 'Postal Address',
        no_beneficial_owners: 'No additional beneficial owners added',
    },
    legal_account_beneficial_owners: {
        add_beneficial_owner: '',
        manager: '',
    },
    legal_account_managers: {
        beneficial_owner: '',
        add_manager: '',
        manager_invited_notice: '',
        pending_invitations: '',
        dialogs: {
            failure_title: '',
            failure_message: '',
            failure_button: '',
            success_title: '',
            success_message: '',
            success_button: '',
            registration_required_title: '',
            registration_required_message: '',
            registration_required_button: '',
            already_accepted_title: '',
            already_accepted_message: '',
            already_accepted_button: '',
            legal_account_already_exists_title: '',
            legal_account_already_exists_message: '',
            legal_account_already_exists_button: '',
        },
    },
    account_links: {
        heading: '',
        orders: '',
        wallet: '',
        secondary_market: 'My Pre-emptive Rights',
    },
    referral_program: {
        your_referral_link: '',
        your_referral_code: '',
        generate_referral_code: '',
        generate_referral_code_description: '',
        generated_referral_code_successfully_message: '',
        generated_referral_code_error_message: '',
        referral_link_social_media_sharing: '',
        referral_info_title: '',
        referral_info_message: '',
        referral_existing_user_title: '',
        referral_existing_user_message: '',
        referral_campaign_not_found_title: '',
        referral_campaign_not_found_message: '',
        referral_success_custom_event_title: '',
        referral_success_custom_event_message: '',
        referral_success_redemption_event_title: '',
        referral_success_redemption_event_message: '',
    },
    verification_kyc_document: {
        show_details_button: '',
        hide_details_button: '',
        uploaded_at: '',
        comment: '',
        valid_to: '',
        verified_at: '',
        add_new_document: '',
        identification_type: '',
        in_progress: '',
        in_progress_description: '',
        on_hold: '',
        on_hold_description: '',
        accepted: '',
        accepted_description: '',
        accepted_not_eligible_for_withdrawal_description: '',
        accepted_not_eligible_for_withdrawal_description_re_upload: '',
        accepted_not_eligible_for_withdrawal_description_contact_support: '',
        rejected: '',
        rejected_description: '',
        unreadable: '',
        unreadable_description: '',
        expired: '',
        expired_description: '',
        wrong_type: '',
        wrong_type_description: '',
        wrong_name: '',
        wrong_name_description: '',
        duplicate_document: '',
        duplicate_document_description: '',
        type: {
            'passport': '',
            'invoice': '',
            'id-card': '',
            'residence-confirmation': '',
            'bank-statement': '',
            'sdd-mandate': '',
            'company-registration': '',
            'articles-of-association': 'Articles of Association',
            'other': '',
            'association-register-extract': 'Commercial/Association Register Extract',
            'list-of-shareholders': 'List of Shareholders',
            'id-of-beneficial-owners': 'ID of Beneficial Owners',
            'id-of-managing-director': 'ID of Managing Director',
            'proof-of-authority-to-represent': 'Proof of Authority to Represent',
        },
    },
    crypto_wallet: {
        request_wallet_button: '',
        notice: '',
        complete_verification_description_for_crypto_wallet: '',
        complete_data_description_for_crypto_wallet: '',
        success_dialog_title: '',
        success_dialog_description: '',
        success_dialog_button: '',
        error_dialog_title: '',
        error_dialog_description: '',
        error_dialog_button: '',
    },
    nyala_vault: {
        pin_info: '',
        reset_pin: '',
        invalid_pin: '',
        enter_a_valid_pin: '',
        reset_initiated_info: '',
        generate_random_pin: '',
        invalid_nyala_pin: '',
        nyala_new_pin: '',
        nyala_confirm_pin: '',
        explorer: '',
        explorer_link: '',
        confirm_pin: '',
        enter_confirm_pin: '',
        pin_confirmed: '',
        nyala_vault_not_created: '',
        vault_not_created_yet_at_nyala: '',
        nyala_passphrase_verification_success_title: '',
        nyala_passphrase_verification_success_message: '',
        nyala_passphrase_verification_expired_link_title: '',
        nyala_passphrase_verification_expired_link_message: '',
        invalid_link: 'Der Link ist nicht mehr gültig!',
    },
    bank_data: {
        iban_from_bank_account_notice: '',
        iban_from_bank_account_link_button: '',
        set_bank_data_from_profile: '',
    },
    bank_account: {
        bank_accounts: '',
        holder: '',
        iban: '',
        status: '',
        is_main: '',
        empty_state_header: '',
        empty_state_description: '',
        main_bank_account: '',
        set_as_main_bank_account: '',
        set_as_main_bank_account_success_message: '',
        in_progress: '',
        accepted: '',
        rejected: '',
        expired: '',
    },
    wallet: {
        my_wallets: 'My Wallets',
        my_wallets_subtitle: 'Overview of my wallets',
        my_wallets_lemonway_note:
            'Currently, there may be restrictions on withdrawals from your wallet. We are working hard on a solution and will keep you informed.',
        deposit: 'Deposit',
        withdraw: 'Withdraw',
        secupay: 'Secupay',
        secupay_amount_info_text: 'Only payment provider, \n No balance to show',
        secupay_verification_not_supported: 'You can not verify bank account with secupay wallet',
        lemonway: 'Lemonway',
        type: 'Wallet Type',
        no_transactions: 'No transactions found',
        vouchers: 'Vouchers',
        last_balance: 'Last balance as of 31.03.2026',
        account_holder: '',
        payment_reference: '',
        payment_amount: '',
        accept_terms: '',
        accept_terms_link: '',
        my_wallet: '',
        my_wallet_subtitle: '',
        legal_wallet: '',
        legal_wallet_subtitle: '',
        no_wallet: '',
        no_wallet_description: '',
        current_balance: '',
        retrievable_balance: '',
        voucher_balance: '',
        withdrawal_button: '',
        withdrawal_header: '',
        withdrawal_description: '',
        verify_bank_account_alert_header: '',
        verify_bank_account_alert_description: '',
        verify_bank_account_alert_action_button: '',
        verify_wallet_alert_header: '',
        verify_wallet_alert_description: '',
        verify_wallet_alert_action_button: '',
        deposit_header: '',
        deposit_via_bank_transfer_header: '',
        deposit_via_bank_transfer_description: '',
        deposit_button: '',
        deposit_description: '',
        withdrawal_button_submit: '',
        deposit_button_submit: '',
        transaction_history: '',
        transaction_history_subtitle: '',
        transaction_history_export_button: '',
        transaction_date: '',
        transaction_title: '',
        transaction_payment_method: '',
        transaction_amount: '',
        edit_profile: '',
        withdrawal_pending_heading: '',
        withdrawal_amount: '',
        withdrawal_account_description: '',
        deposit_amount: '',
        confirm_withdrawal_title: '',
        confirm_withdrawal_description: '',
        cancel_wallet_withdrawal_confirm_heading: '',
        cancel_wallet_withdrawal_confirm_description: '',
        cancel_wallet_withdrawal: '',
        cancel_wallet_withdrawal_success: '',
        cancel_wallet_withdrawal_error: '',
        withdrawal_bank_account: '',
        withdrawal_bank_account_select: '',
        payment_options: {
            bank_transfer: 'Bank Transfer',
            credit_card: 'Credit Card',
        },
        lw_trasaction_type: {
            0: '',
            1: '',
            2: '',
        },
        lw_trasaction_method: {
            0: '',
            1: '',
            4: '',
            3: '',
            13: '',
            14: '',
            15: '',
            16: '',
            17: '',
            18: '',
            19: '',
            20: '',
            21: '',
            22: '',
            23: '',
            24: '',
            25: '',
            26: '',
            27: '',
            28: '',
            29: '',
        },
        dialogs: {
            money_withdrawal_verification_expired_link_title: '',
            money_withdrawal_verification_expired_link_message: '',
            money_withdrawal_verification_no_longer_pending_title: '',
            money_withdrawal_verification_no_longer_pending_message: '',
            money_withdrawal_verification_success_title: '',
            money_withdrawal_verification_success_message: '',
            money_deposit_successful_title: '',
            money_deposit_successful_description: '',
            money_deposit_canceled_title: '',
            money_deposit_canceled_description: '',
            money_deposit_error_title: '',
            money_deposit_error_description: '',
            success_button: '',
            failure_button: '',
        },
    },
    voucher: {
        balance: '',
    },
    table: {
        pagination_results_overview: '',
        next: '',
        previous: '',
    },
    pending_investment_process: {
        title: '',
        description: '',
        resume_button: '',
        cancel_button: '',
    },
    texts: {
        email_change_notice: '',
        required: '',
        required2: '',
    },
    widget: {
        save: 'Save + Next',
        back: 'Back',
        sign_up_as: 'I am signing up as',
        natural_person: 'Natural Person',
        legal_entity: 'Legal Entity',
        step_counter: 'Step {currentStep} of {totalSteps}',
        close: 'Cancel',
    },
    esac_widget_sidebar: {
        // prettier-ignore
        natural_legal_select:
            '<p>Welcome to the KYC Wizard for the Investment Platform of the European Superangels Club. Once you have completed the KYC process (including uploading of supporting documentation and approval by Venionaire Ventures), you can access all investments on this platform, and also invest in opportunities. </p>' +
            '<p>If you have questions about the KYC process, or require assistance, please contact our support team at <a href="mailto:platform{\'@\'}superangels.club">platform{\'@\'}superangels.club</a>. </p>' +
            '<p>This process will take about 5 minutes for Natural Persons and 10-15 minutes for Legal Entities. </p>' +
            '<p>You will need the following information ready:</p>' +
            '<p><strong>Natural Person:</strong><br>' +
            '<ul><li>Tax information</li></ul></p>' +
            '<p><strong>Legal Entity:</strong> <br>' +
            '<ul><li>Tax information</li>' +
            '<li>CRS and FATCA classifications</li>' +
            '<li>Investment experience of second authorised signatory (if applicable)</li></ul></p>',
        natural_personal_data: 'Please complete your personal details.',
        natural_address_data:
            'Please provide your residential and postal address (if different). The residential address needs to correspond with your proof of address that you will upload later in the KYC process.',
        natural_investment_targets:
            'For you as an investor, it is important that we get to know your general attitude towards the type of investment, your risk-disposition, risk-bearing capacity, and risk knowledge. We therefore ask you to truthfully complete this form.',
        financial_conditions:
            'Please complete the information on your financial position. We are required to understand your risk-bearing capacity in relation to your approximate net financial wealth.',
        natural_experience_and_knowledge:
            'Please confirm your knowledge of and your practical investment experience in the instruments listed.',
        natural_fatca: 'Please confirm your FATCA status.',
        natural_tax: 'Please confirm your tax situation, and the countries of which you are a tax resident.',
        acknowledgements:
            'Please carefully read and confirm the statements provided. These will be electronically signed on the KYC forms.',
        natural_kyc_form:
            'Congratulations on completing the KYC wizard!\n' +
            ' This Form "Investor Questionnaire" includes all the information and acknowledgements you have just given. Please carefully review the form and sign it electronically. \n' +
            'You will also need to upload supporting documentation.\n' +
            'The form and documentation will then be reviewed by Venionaire Ventures, and once approved, you will be notified and can access all Investment Opportunities on this platform. We will contact you if we have any question.<br><br>' +
            'If an electronic signature is not possible, please print out the contract, sign the hard copy, and send it to:<br><br>' +
            'Venionaire Capital AG<br>' +
            'Babenbergerstraße 9/12<br>' +
            'A-1010 Vienna, Austria (EU)',
        legal_company_information:
            'Please supply registration information on the investing entity (hereinafter the "Investor" or "Entity"). \n' +
            'Please note that in this wizard Managing Directors ("MD") are defined as the authorised signatories of the Investor; Ultimate Beneficial Owners ("UBO") own or control an interest in the Investor (legal entity). \n' +
            'Please add any UBO who owns 20% or more of the share capital and/or voting rights as well as all MDs that are required to duly represent the Investor and decide on a potential investment.',
        legal_address_information: 'Please enter the registered address of the investing entity.',
        legal_manager_one_personal: 'Please complete your personal information and select the type of control.',
        legal_manager_two_personal:
            'Please complete the Personal Information of the respective MD or UBO and select the type of control.',
        legal_managers_ubo_overview:
            'Please add a potential co-Managing Director (joint representation of the investing Legal Entity), as well as other beneficial owners (ownership > 20%) of the investing Legal Entity (if applicable).',
        legal_manager_one_address: 'Please complete your address.',
        legal_manager_two_address: 'Please complete the residential address of the respective MD or UBO.',
        legal_manager_one_tax: 'Please complete your tax and ownership information',
        legal_manager_two_tax: 'Please complete the tax and ownership information of the respective MD or UBO.',
        // prettier-ignore
        legal_entity_investment_profile:
            'It is important that we get to know the Investor\'s general attitude towards the type of investment, its risk-disposition, risk-bearing capacity, and risk knowledge. We therefore ask you to truthfully complete this section for the Investor.',
        legal_entity_financial_position:
            'Please complete this information on the entity’s financial position. This is to understand the entity’s risk-bearing capacity in relation it’s approximate net financial wealth.',
        legal_manager_one_experience_and_knowledge:
            'Please indicate your personal experience in and knowledge of the indicated asset classes, as well as finance markets. Please complete this personally as the MD (and not for the investing Legal Entity).',
        legal_manager_two_experience_and_knowledge:
            'Please indicate MD 2’s personal experience in and knowledge of the indicated asset classes, as well as finance markets.',
        legal_manager_two_authorization:
            'Please complete MD 2’s Investment Experience and Knowledge, with her/his approval. This will be included in a KYC form that will be signed by both managers.',
        legal_entity_fatca:
            'The information in this section is for FATCA purposes. Please note that this classification may differ from your CRS classification.',
        legal_entity_tax_situation:
            'Please confirm the Entity’s tax situation, and the countries of which it is a tax resident.',
        legal_entity_crs: 'Please select the CRS classification of the Entity:',
        legal_acknowledgements:
            'Please carefully read and confirm the statements provided. These will be electronically signed on the KYC forms.',
        legal_beneficial_owner: 'Please complete the Personal Information of the respective beneficial owner.',
        legal_kyc_form:
            'Thank you for completing the KYC wizard! The form “ESAC legal entity” includes all the information and acknowledgements you have just given. Please carefully review the form and sign it electronically. If you have a second required signatory (MD 2), he/she is also required to sign this form. The partially prefilled document(s) “ESAC  Legal UBO for ...” has/have to be completed and signed by the respective Beneficial Owner(s). The completed and signed document(s) need(s) to be uploaded under the company account page on the platform (select your profile on the top right corner, then company account, and Signatures on the bottom left). \n' +
            'The forms and documentation will then be reviewed by Venionaire Ventures, and once approved, you will be notified and can access all Investment Deals on the platform. We will be in touch if we have any questions about your form or documents.',
    },
    security: {
        password: {
            title: '',
            hint: '',
            update: '',
        },
        two_factor_authentication: {
            title: '',
            hint: '',
            configure: '',
            list_title: '',
            type: '',
            types: {
                otp: '',
                sms: '',
                passkey: '',
            },
            user_label: '',
            date: '',
            action: '',
            remove: '',
            non_removeable: '',
            remove_success: '',
        },
        dialogs: {
            error_title: '',
            error_message: '',
            success_title: '',
            success_message: '',
        },
        external_security_link: {
            title: '',
            hint: '',
            redirect: '',
        },
    },
    dialog: {
        button: {
            confirm: '',
            cancel: '',
            back: '',
            close: '',
            ok: '',
        },
        formDirty: {
            title: '',
            text: '',
            confirm: '',
            cancel: '',
        },
        formInvalid: {
            title: '',
            text: '',
        },
        iframe_link_notice: '',
        iframe_link_notice_link: '',
    },
    yes_no_deny: {
        yes: '',
        no: '',
        no_answer: '',
    },
}
